import React from 'react';
import styled from 'styled-components';
import Button from './button';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

function SelectorChart({ payload, selected, disabled, onChange }) {
  return (
    <Wrapper>
      {payload.map((term, index) => (
        <Button
          key={term.value}
          term={term}
          position={index}
          selected={selected}
          disabled={disabled}
          onChange={onChange}
        />
      ))}
    </Wrapper>
  );
}

export default SelectorChart;
